import React, { useCallback, useContext, useEffect, useState } from 'react'
import './TaskBlueprints.css'
import { Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faProjectDiagram, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { GlobalAgGridTable } from '../Deal/AgGridReactComponent/GlobalAgGridTable';
import { CreateBlueprint } from './CreateBlueprint';
import AwsServerService from '../../common/util/AwsServerService';
import AppContext from '../../Context/AppContext';
import UserService from '../../common/util/UserService';
import Lock from '../../assets/images/svg/Lock.svg'
import VerticleDots from '../../assets/images/svg/VerticleDots.svg'
import DefaultFlow from '../../assets/images/svg/DefaultFlow.svg'
import swal from "sweetalert";
import { Button, message } from 'antd';
import { refershModule, Socket } from '../../Context/AppActions';
import { ToolBox } from '../../common/ShortcutsToolbox/ToolBox';
import { FolderPicker } from '../FolderPicker/FolderPicker';
import { NamingConvPopup } from '../NamingConvention/HashTagInput';
import { useParams } from 'react-router-dom';
import Loader from '../../common/loader';
import moment from 'moment';
import { setRefershModule } from '../../Context/ReduxContext';
import { useDispatch, useSelector } from "react-redux";
import { canAccess } from '../../common/util/appUtils';
const TaskBlueprints = ({history,location,getParams}) => {
  const AppData = useContext(AppContext);
  const { dispatch ,state} = AppData || {};
  const params = useParams();
  useEffect(() => {
    if (getParams) {
      getParams(params);
    }
  }, [location]);
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [view,setView] = useState("list");
  const [refresh,setRefresh] = useState(false);
  const [editFlow,setEditFlow] = useState();
  const [toolboxposition, setToolboxPosition] = useState({ x: 0, y: 0 });
  const [isToolBox, setIsToolBox] = useState({ state: false, object: null });;
  const [allBlueprintData,setAllBlueprintData] = useState([])
  const [cacheAllBlueprintData,setCacheAllBlueprintData] = useState([])
  const reduxDispatch = useDispatch();
  const RefershModule = useSelector((state) => state.AppReduxContext.refershModule)
  const [allUsers,setAllUsers]=useState([]);
  const [allUserRoles,setAllUserROles]=useState([]);
  // useEffect(e => {
  //   AwsServerService.ensureFolderPathExists("4luep6e60a2c5e67f4499a92b1d91f324511f", ["Documents", "Test",], localStorage.getItem('token')).then(id=>{
  //     console.log("Folder ID ---- ",id);
  //   })
  // }, [])
  useEffect(()=>{
    UserService.GetAllUsers().then(r=>{
     setAllUsers(r.data.users)
    })
    UserService.GetAllUserRoles().then(e=>{
     setAllUserROles(e.data.roles)
    })
  },[])
  const [reloadFlow,setReloadFlow] = useState(false);
  const [loader,setLoader] = useState(false);
  useEffect(() => {
    if (params && params?.ROWID ) {
      setLoader(true);
      AwsServerService.getTaskFlowById(params.ROWID).then((res)=>{
        if(res.data[0][0]){
          setEditFlow(res.data[0][0]);
          setView("edit")
        }else{
          setView("list")
          setEditFlow(null);
        }
        setLoader(false);
      }).catch(e=>{
        setLoader(false);
        console.log(e);
      })
    } else {
      setView("list")
      setEditFlow(null);
    }
  }, [params?.ROWID,reloadFlow]);
  function RenderFlowName(params) {
    let btnDiv=document.createElement("div");
    btnDiv.className="Task-Name-Wrapper";
    let img=document.createElement("img");
    let img1=document.createElement("img");
    let img2=document.createElement("img");

    img.src=Lock;
    img1.src=VerticleDots;
    img2.src=DefaultFlow;

    let label=document.createElement("label");
    let icon=document.createElement("span");
    icon.className="Setting-Iconwrapper-For-Flow";
    icon.appendChild(img1);

    icon.addEventListener("contextmenu",(e)=>{
      handleContextMenu(e,params)
    })
    icon.addEventListener("click",(e)=>{
      
      const x = e.clientX;
      const y = e.clientY;
      const event = new MouseEvent('contextmenu', {
        bubbles: true,
        cancelable: true,
        view: window,
        clientX: x, // X coordinate
        clientY: y,  // Y coordinate
        button: 2 // Simulate right-click
      });
      icon.dispatchEvent(event);
    })

    label.innerText=params.Name
    if(params.DefaultFlow=="true"){
      btnDiv.appendChild(img2);
    }
    btnDiv.appendChild(label);
    btnDiv.appendChild(icon);
    if(params.LockFlow=="true"){
      btnDiv.appendChild(img);
    }
    return btnDiv;
  }
  const actionListCellRenderer= (params)=> {  
    const canEdit = canAccess(accessContext, "Task Flows", "Edit");
    const canDelete = canAccess(accessContext, "Task Flows", "Delete");
    console.log(params);
    let btnDiv=document.createElement("div");
    btnDiv.classList.add("global-action-btn-for-tables");
    
    let editBtn=document.createElement('button');
    editBtn.classList.add("add")
    editBtn.innerText="Edit"
    editBtn.id=params.ROWID;
    editBtn.addEventListener('click',(e)=>{  
      if(!canEdit){
        message.error("Permission Denied");
        return;
      }
      let Rowid=e.currentTarget.id;
      const currentPath = history.location.search;
      let newUrl = `/setting/taskflows/${Rowid}`;
      // if (!currentPath.includes(`taskId`)) {
        history.push(newUrl)
      // }
      // if(params.ROWID == Rowid){
      //   setEditFlow(params);
      //   setView("edit")
      // }
    })
    let deleteBtn=document.createElement('button');
    deleteBtn.classList.add("add")
    deleteBtn.style.color="red";
    deleteBtn.innerText="Delete";
    deleteBtn.id=params.ROWID;
    deleteBtn.addEventListener('click',(e)=>{ 
      if(!canDelete){
        message.error("Permission Denied");
        return;
      }
      let Rowid=e.currentTarget.id;
      swal({
        title: "Warning!",
        text: "Are you sure you want to delete the flow?",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "Proceed",
        },
      }).then(async(isDelete)=>{
        if(isDelete){
          AwsServerService.deleteTaskFlow(Rowid).then(res=>{
            dispatch(Socket({trigger:"Refresh_Module",data:"Task Flow"}))
          })
        }
      })})
    if(params.DefaultFlow=='true'){
      deleteBtn.disabled = true;
      deleteBtn.style.opacity = 0.5;
      deleteBtn.style.cursor = "not-allowed";
      deleteBtn.title = 'Shift the Default flow before deleting.';
    }
    btnDiv.appendChild(editBtn);
    btnDiv.appendChild(deleteBtn);
    return btnDiv;
  }
  console.log("dat blue", allBlueprintData);
  const sidebarEmailContext = [
    {
      label: "Set As Default",
    //   icon: () => {
    //     return (
    //       <FontAwesomeIcon color='black' icon={faPlus} />
    //     )
    //   },
      module: ['TaskFlow'],
      action: async (e, data, refrence) => {
        let old=allBlueprintData.find(b=>b.DefaultFlow=='true');
        swal({
          title: "Warning!",
          text: "Are you sure you want to change the default flow?",
          icon: "warning",
          buttons: {
            cancel: "Cancel",
            confirm: "Yes",
          },
        }).then(async(isYes)=>{
          if(isYes){
            if(old){
              await AwsServerService.updateTaskFlow({
                "ROWID": old.ROWID,
                "DefaultFlow": 'false',
              }).then(res => {
              }).catch(err => {
                console.log(err);
              })
            }
            await AwsServerService.updateTaskFlow({
              "ROWID": refrence.ROWID,
              "DefaultFlow": 'true',
            }).then(res => {
              dispatch(
                Socket({ trigger: "Refresh_Module", data: "Task Flow" })
              );
            }).catch(err => {
              console.log(err);
            })
          }
        })
      }
    },
  ]
  const handleContextMenu = (e, one, module) => {
    e.preventDefault();
    setIsToolBox({ state: true, object: one });
    setToolboxPosition({ x: e.clientX, y: e.clientY - 50 });
  };
  const getToolBoxForFlag = () => {
    return (
      <ToolBox
        module={"TaskFlow"}
        selectedMails={""}
        setOpen={(status) => {
            setIsToolBox(status);
        }}
        isOpen={isToolBox}
        position={toolboxposition}
        content={sidebarEmailContext}
      />
    )
  }
  const columnForZoho = [
    {
      field: "Name",
      name: "Task Flow Name",
      path: "Name",
      key: "Action",
      type:"text",
      label: "Task Flow Name",
      id : 0,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      content: (obj) => {
        return RenderFlowName(obj)
        // <label 
        // // hidden={selectedTbl === "dayView"} 
        // >
        //   {obj.Name} 
        // </label>
        }
    },
    {
      field: "Description",
      name: "Description",
      path: "Description",
      type:"text",
      label: "Description",
      id : 1,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      cellStyle:{textAligh:"left"},
      content: (obj) => (
        <label 
        // hidden={selectedTbl === "dayView"} 
        >
          {obj.Description}
        </label>
      ),
    },
    {
      field: "MODIFIEDTIME",
      name: "Last Modified",
      key: "Last_Modified",
      path: "Last_Modified",
      type:"text",
      label: "Last Modified",
      id : 2,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      content: (obj) => {
      return moment(obj.MODIFIEDTIME).format('MM/DD/YYYY hh:mm A')  
      },
    },
    {
      field: "Action",
      key: "Action",
      name: "Action",
      path: "Action",
      type:"text",
      label: "Action",
      id : 3,
      isChecked : false,
      isDragOver : false,
      isSearch : true,
      content:  actionListCellRenderer,
    },
  ];
    useEffect(e=>{
      if(RefershModule?.module=="Task Flow"){
        setRefresh(!refresh);
        reduxDispatch(setRefershModule(null))
      }
    },[RefershModule])
    useEffect(()=>{
      AwsServerService.getAllTaskFlows().then(res=>{
        setAllBlueprintData(res);
        setCacheAllBlueprintData(res);
      }).catch(err=>{
        console.log(err);
      })
    },[refresh])
    const extraComponentToRight=(e)=>{
      return (
        <div className="extra-component-request-toRight">
          <div className="job-action-box">
            <Button
              style={canAccess(accessContext, "Task Flows", "Create") ? {} : {opacity: 0.2, pointerEvents: "none", cursor: "not-alloweds"}}
              type='primary'
              className="mr-3 request-btns"
              onClick={() => {
                setView("create");
              }}
            >
              Create Task Flow
            </Button>
          </div>
        </div>
      );
    }
  return (
    <div className='Blueprint-Wrapper'>
      {loader && <Loader/>}
      {getToolBoxForFlag()}
      {/* <FolderPicker /> */}
        {/* <div className='Blueprint-Header'>
            <Row className=''>
                <Col className='d-flex align-items-center' sm={4}><FontAwesomeIcon className='logo' icon={faProjectDiagram} /><span style={{fontSize:"1rem",fontWeight:"600", marginLeft:"10px"}}>Blueprints</span></Col>
                <Col sm={4}></Col>
                <Col sm={4}></Col>
            </Row>
        </div> */}
        <div id="myGrid" className='ag-theme-alpine Blueprint-Body'>
          {view == "list" ? <GlobalAgGridTable
            headers={columnForZoho}
            setRowData={setAllBlueprintData}
            cacheRowData={cacheAllBlueprintData}
            setCacheRowData={setCacheAllBlueprintData}
            module="Task Flows"
            mainUrl="blueprint"
            // DropDownFields={["User Name", "Check In", "Check Out"]}
            rowData={allBlueprintData}
            renderExtraComponent={()=><></>}
            renderExtraComponentToRight={extraComponentToRight}
            isTaskFilterHide={true}
          /> : view == "create" || view == "edit"? 
          <CreateBlueprint
            setEditFlow={setEditFlow}
            editFlow={editFlow}
            setReloadFlow={setReloadFlow}
            reloadFlow={reloadFlow}
            view={view }
            allBlueprintData={allBlueprintData}
            close={()=>{
               
              if(view!="create"){
                history.goBack();
              }
              setView("list")
              setEditFlow(null);
            }}
            allUserRoles={allUserRoles}
            allUsers={allUsers}
          />:<></>}
        </div>
    </div>
  )
}

export default TaskBlueprints
